import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusTodo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: 4,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.4053 12.0918V13.4043H7.78906V12.0918H11.4053ZM16.1631 12.0918V13.4043H12.5469V12.0918H16.1631Z",
		fill: "black"
	})]
});
export default SvgStatusTodo;
